// CSV export helper for Bullion Admin
export const exportTradesToCSV = (trades, filename = "GJ_Bullion_Trades.csv") => {
  if (!trades || trades.length === 0) {
    alert("No trades to export.");
    return;
  }

  const headers = [
    "Trade ID",
    "Date & Time",
    "Customer Name",
    "Customer Phone",
    "Metal",
    "Action",
    "Rate (INR)",
    "Quantity",
    "Total Price (INR)",
    "Rate Source"
  ];

  const rows = trades.map((t, idx) => {
    const tradeDate = t.timestamp ? new Date(t.timestamp).toLocaleString("en-IN") : "";
    const name = t.fullName || (t.userId && t.userId.fullName) || "N/A";
    const phone = t.phone || (t.userId && t.userId.phone) || "N/A";
    const metal = t.metal || "";
    const action = t.action ? t.action.toUpperCase() : "";
    const rate = t.rate || 0;
    const qty = t.quantity || "";
    const totalPrice = t.totalPrice || 0;
    const rateSource = t.rateSource || "live";

    return [
      `"${t._id || idx + 1}"`,
      `"${tradeDate}"`,
      `"${name.replace(/"/g, '""')}"`,
      `"${phone}"`,
      `"${metal.replace(/"/g, '""')}"`,
      `"${action}"`,
      rate,
      `"${qty}"`,
      totalPrice,
      `"${rateSource}"`
    ].join(",");
  });

  const csvContent = "\uFEFF" + [headers.join(","), ...rows].join("\r\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
